const merge = require('lodash/merge');
import TWEEN from '@tweenjs/tween.js';
const { Easing } = TWEEN;

/**
 * Motion Principles
 */
const definitions = {
  // Quick - for savvy users
  quick: {
    duration: {
      js: 330,
      css: '330ms',
    },
    easing: {
      in: {
        // http://easings.net/#easeInQuint
        js: Easing.Quintic.In,
        css: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
      },
      out: {
        // http://easings.net/#easeOutQuint
        js: Easing.Quintic.Out,
        css: 'cubic-bezier(0.23, 1, 0.32, 1)',
      },
    },
  },

  // Soft and timed - for non experts
  soft: {
    duration: {
      js: 860,
      css: '860ms',
    },
    easing: {
      in: {
        // http://easings.net/#easeInQuart
        js: Easing.Quartic.In,
        css: 'cubic-bezier(0.895, 0.03, 0.685, 0.22)',
      },
      out: {
        // http://easings.net/#easeOutQuart
        js: Easing.Quartic.Out,
        css: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
      },
    },
  },
};

// Motion values used as Sass variables
const motion = {
  transition: {
    duration: definitions.quick.duration.css,
    timing: definitions.quick.easing.out.css,
    soft: {
      duration: definitions.soft.duration.css,
      timing: definitions.soft.easing.out.css,
    },
  },
  sequence: {
    delay: definitions.quick.duration.css,
  },
};

// A dynamic ‘motion palette’, customisable per application
const palette = {
  /**
   * A ‘foundation’ duration value, which can be multiplied as necessary when
   * composing animations, e.g. pause for 0.5×duration, animate for 1×duration
   */
  duration: definitions.quick.duration.js,

  /**
   * Easing functions to be used as your application motion specs dictate
   */
  easing: {
    in: definitions.quick.easing.in.js,
    out: definitions.quick.easing.out.js,
  },
};

function setPalette(overrides = {}) {
  // Mutate palette object
  merge(palette, overrides);
}

export default { definitions, motion, palette, setPalette };
